import { render, staticRenderFns } from "./ChallengeFriends.vue?vue&type=template&id=3a758ec6&scoped=true"
import script from "./ChallengeFriends.vue?vue&type=script&lang=js"
export * from "./ChallengeFriends.vue?vue&type=script&lang=js"
import style0 from "./ChallengeFriends.vue?vue&type=style&index=0&id=3a758ec6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a758ec6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a758ec6')) {
      api.createRecord('3a758ec6', component.options)
    } else {
      api.reload('3a758ec6', component.options)
    }
    module.hot.accept("./ChallengeFriends.vue?vue&type=template&id=3a758ec6&scoped=true", function () {
      api.rerender('3a758ec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/challenge-friends/components/ChallengeFriends.vue"
export default component.exports